import React from "react";
import "./styles.css";

const Msg = ({ data }) => {
  return (
    <div className={`msg ${data.type}`}>
      {data.type === "error" ? (
        <i className="fa fa-times-circle fa-lg" />
      ) : data.type === "success" ? (
        <i className="fa fa-check-circle fa-lg" />
      ) : (
        <i className="fa fa-circle-o-notch fa-spin fa-lg" />
      )}
      <span>{data.text}</span>
    </div>
  );
};

export default Msg;
